import { createSelector, createFeatureSelector } from '@ngrx/store';

export const getUsersManagementContext = createFeatureSelector('spUsersManagementContext');

export const getUserList = createSelector(getUsersManagementContext, (state: any) => state.UsersList);
export const getUsersLoaded = createSelector(getUsersManagementContext, (state: any) => state.usersLoaded);
